import * as React from 'react';
import { twMerge } from 'tailwind-merge';

interface BeaconLogoProps extends React.SVGAttributes<SVGSVGElement> {
  height?: number;
}

const TEXT_X = 32.198;
const BREAKLINE_X = 47.917;

export const BeaconLogo = React.forwardRef<SVGSVGElement, BeaconLogoProps>(
  ({ height = 30, className, ...rest }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 30"
        height={height}
        width={(height * 10) / 3}
        fill="none"
        role="img"
        aria-label="Beacon by BreakLine"
        className={twMerge('shrink-0 font-sans', className)}
        {...rest}
      >
        <path
          stroke="var(--color-primary-9)"
          strokeWidth="1.14583"
          d="M10.1979 24.625C15.5137 24.625 19.8229 20.3157 19.8229 15C19.8229 9.68426 15.5137 5.375 10.1979 5.375C4.88218 5.375 0.572922 9.68426 0.572922 15C0.572922 20.3157 4.88218 24.625 10.1979 24.625Z"
        />
        <path
          stroke="var(--color-text-1)"
          strokeWidth="1.14583"
          opacity="0.85"
          d="M10.1979 20.9583C13.4886 20.9583 16.1563 18.2907 16.1563 15C16.1563 11.7093 13.4886 9.04167 10.1979 9.04167C6.90723 9.04167 4.23959 11.7093 4.23959 15C4.23959 18.2907 6.90723 20.9583 10.1979 20.9583Z"
        />
        <path
          fill="var(--color-primary-9)"
          d="M10.1979 16.8333C11.2104 16.8333 12.0313 16.0125 12.0313 15C12.0313 13.9875 11.2104 13.1667 10.1979 13.1667C9.1854 13.1667 8.36459 13.9875 8.36459 15C8.36459 16.0125 9.1854 16.8333 10.1979 16.8333Z"
        />
        <path stroke="var(--color-primary-9)" strokeWidth="1.14583" d="M10.1979 4.45833V7.66667" />
        <path stroke="var(--color-primary-9)" strokeWidth="1.14583" opacity="0.5" d="M10.1979 22.3333V25.5417" />

        <text x={TEXT_X} y={14} fill="var(--color-text-1)" fontSize={15} fontWeight={600} letterSpacing="0.06em">
          BEACON
        </text>
        <text y={27} fontSize={11}>
          <tspan x={TEXT_X} className="fill-[#55657B] dark:fill-[#8A929C]" fontWeight={400}>
            by
          </tspan>
          <tspan x={BREAKLINE_X} fill="var(--color-text-1)" fillOpacity={0.75} fontWeight={500}>
            BreakLine
          </tspan>
        </text>
      </svg>
    );
  },
);

BeaconLogo.displayName = 'BeaconLogo';
